import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LocationMarkerFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LocationMarkerFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M19.07 2.931c-3.91-3.91-10.24-3.91-14.14 0-3.91 3.91-3.91 10.24 0 14.14l7.07 6.93 7.07-6.93c3.91-3.91 3.91-10.24 0-14.14ZM12 12.501a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default LocationMarkerFilled;